import { LoadingCommon } from "@components";
import { COMMON_ERR_NO_PERMISSION, images, MAX_LENGTH_255 } from "@constants";
import { ArrowLeftIcon } from "@constants/svgs";
import { handleShowToastError } from "@utils/helpers";
import { MODAL_TYPE, USER_ROLE } from "@utils/constants";
import { Col, Form, Input, Row, Select } from "antd";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { adminPaths } from "routers/routes";
import {
  LIST_KEYS_ALLOW_PHONE,
  MAX_LENGTH_11,
  MAX_LENGTH_STORE_CODE,
  MAX_LENGTH_50,
  STORE_PAGE_CONSTANT,
} from "./constant";
import { ModalDeleteWrapper, ModalWrapper } from "./StorePageStyled";
import { CommonMasterPage } from "@components/CommonMasterPage/CommonMasterPage";
import useStorePage from "./hooks/useStorePage";
import { useCurrentUserRole } from "@hooks";

const { FORM_NAME } = STORE_PAGE_CONSTANT;

function StorePage() {
  const { t } = useTranslation();
  const currentUserRole = useCurrentUserRole();
  const { state, handler } = useStorePage();

  const dropdownPlaceholder = t("COMMON.DROP_DOWN_PLACE_HOLDER");
  const inputPlaceholder = t("COMMON.INPUT_PLACE_HOLDER");
  const cancelText = t("COMMON.CANCEL");

  const FIELDS_CONFIG = {
    // Form search
    COMPANY: {
      required: false,
      label: t("STORE_PAGE.COMPANY_COL"),
      name: FORM_NAME.COMPANY,
    },
    AREA: {
      required: false,
      label: t("STORE_PAGE.AREA_COL"),
      name: FORM_NAME.AREA,
    },
    STORE: {
      required: false,
      label: t("STORE_PAGE.STORE_COL"),
      name: FORM_NAME.STORE,
    },

    // Form modal
    COMPANY_MODAL: {
      required: false,
      label: (
        <>
          <span style={{ color: "#d92d20", marginRight: "4px" }}>*</span>
          {t("STORE_PAGE.COMPANY_MODAL")}
        </>
      ),
      name: FORM_NAME.COMPANY_MODAL,
    },
    AREA_MODAL: {
      required: false,
      label: (
        <>
          <span style={{ color: "#d92d20", marginRight: "4px" }}>*</span>
          {t("STORE_PAGE.AREA_MODAL")}
        </>
      ),
      name: FORM_NAME.AREA_MODAL,
    },
    STORE_CODE_MODAL: {
      required: false,
      label: (
        <>
          <span style={{ color: "#d92d20", marginRight: "4px" }}>*</span>
          {t("STORE_PAGE.STORE_CODE_MODAL")}
        </>
      ),
      name: FORM_NAME.STORE_CODE_MODAL,
    },
    STORE_NAME_MODAL: {
      required: false,
      label: (
        <>
          <span style={{ color: "#d92d20", marginRight: "4px" }}>*</span>
          {t("STORE_PAGE.STORE_NAME_MODAL")}
        </>
      ),
      name: FORM_NAME.STORE_NAME_MODAL,
    },
    EMAIL_MODAL: {
      required: false,
      label: t("STORE_PAGE.EMAIL_MODAL"),
      name: FORM_NAME.EMAIL_MODAL,
    },
    MOBILE_PHONE_MODAL: {
      required: false,
      label: t("STORE_PAGE.MOBILE_PHONE_MODAL"),
      name: FORM_NAME.MOBILE_PHONE_MODAL,
    },
  };

  const handleRedirectUser = () => {
    handleShowToastError(COMMON_ERR_NO_PERMISSION, t("STORE_PAGE.PAGE_TITLE"));
    return <Navigate to={adminPaths.fixedAssetLedger} />;
  };

  return (
    <>
      {currentUserRole === USER_ROLE.STORE_OWNER ? (
        handleRedirectUser()
      ) : (
        <LoadingCommon loading={state.isLoading}>
          <CommonMasterPage
            tableRef={state.tblRef}
            handleOpenRegisModal={handler.handleOpenModalRegis}
            handleClearSearch={handler.handleClearSearch}
            handleSearch={handler.handleSearch}
            handleScroll={handler.handleScroll}
            pageName="STORE_PAGE"
            commonName="COMMON"
            form={state.form}
            columns={state.columns as any}
            listData={state.listStores}
            rowKey={state.rowKey}
            listItems={[
              {
                fieldConfig: FIELDS_CONFIG.COMPANY,
                element: (
                  <Select
                    onChange={handler.handleChangeCompany}
                    size="large"
                    placeholder={dropdownPlaceholder}
                    options={state.companyDropdownData}
                  />
                ),
              },
              {
                fieldConfig: FIELDS_CONFIG.AREA,
                element: (
                  <Select
                    onChange={handler.handleChangeArea}
                    size="large"
                    placeholder={dropdownPlaceholder}
                    options={state.areaDropdownData}
                  />
                ),
              },
              {
                fieldConfig: FIELDS_CONFIG.STORE,
                element: (
                  <Select
                    size="large"
                    placeholder={dropdownPlaceholder}
                    options={state.storeDropdownData}
                  />
                ),
              },
            ]}
          />

          {/* MODAL REGIS/UPDATE/DETAIL */}
          <ModalWrapper
            width={800}
            title={
              <>
                {state.modalType === MODAL_TYPE.CONFIRM_REGISTRATION && (
                  <button
                    onClick={() =>
                      handler.setModalType(MODAL_TYPE.REGISTRATION)
                    }
                  >
                    <ArrowLeftIcon />
                  </button>
                )}
                {state.modalType === MODAL_TYPE.CONFIRM_UPDATE && (
                  <button
                    onClick={() => handler.setModalType(MODAL_TYPE.UPDATE)}
                  >
                    <ArrowLeftIcon />
                  </button>
                )}
                <span>{state.renderTextModal.title}</span>
              </>
            }
            closeIcon={false}
            maskClosable={false}
            okText={state.renderTextModal.okText}
            cancelText={cancelText}
            destroyOnClose={true}
            open={state.modalOpen}
            centered
            onCancel={() => {
              handler.handleCloseModal();
            }}
            loading={state.loadingModal}
            onOk={() => {
              if (state.modalType === MODAL_TYPE.DETAIL) {
                handler.handleCloseModal();
              } else if (state.modalType === MODAL_TYPE.UPDATE) {
                handler.handleValidateForm();
              } else if (state.modalType === MODAL_TYPE.CONFIRM_REGISTRATION) {
                handler.handleOpenModalConfirmFinal();
              } else if (state.modalType === MODAL_TYPE.CONFIRM_UPDATE) {
                handler.handleOpenModalConfirmFinal();
              } else {
                handler.handleValidateForm();
              }
            }}
            okButtonProps={{
              style: {
                width: state.modalType === MODAL_TYPE.DETAIL ? "100%" : "368px",
              },
              disabled: state.disableBtnNext,
            }}
            cancelButtonProps={{
              style: {
                display:
                  state.modalType === MODAL_TYPE.DETAIL ? "none" : "block",
              },
            }}
          >
            <Form
              layout="vertical"
              form={state.formModal}
              preserve={false}
              disabled={state.disableFields}
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item {...FIELDS_CONFIG.COMPANY_MODAL}>
                    <Select
                      disabled={state.disableFieldsEdit}
                      size="large"
                      placeholder={dropdownPlaceholder}
                      options={state.companiesModal}
                      onChange={(val) =>
                        handler.handleChangeCompaniesModal(val)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...FIELDS_CONFIG.AREA_MODAL}>
                    <Select
                      size="large"
                      placeholder={dropdownPlaceholder}
                      options={state.areasModal}
                      onChange={(value) => {
                        state.formModal.setFieldValue(
                          FORM_NAME.AREA_MODAL,
                          value
                        );
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...FIELDS_CONFIG.STORE_CODE_MODAL}>
                    <Input
                      disabled={state.disableFieldsEdit}
                      maxLength={MAX_LENGTH_STORE_CODE}
                      size="large"
                      placeholder={inputPlaceholder}
                      onKeyDown={(event) => {
                        if (event.code === "Space") {
                          event.preventDefault();
                        }
                      }}
                      onBlur={(event) => {
                        state.formModal.setFieldValue(
                          FORM_NAME.STORE_CODE_MODAL,
                          event.target.value.trim()
                        );
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...FIELDS_CONFIG.STORE_NAME_MODAL}>
                    <Input
                      maxLength={MAX_LENGTH_50}
                      size="large"
                      placeholder={inputPlaceholder}
                      onBlur={(event) => {
                        state.formModal.setFieldValue(
                          FORM_NAME.STORE_NAME_MODAL,
                          event.target.value.trim()
                        );
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...FIELDS_CONFIG.EMAIL_MODAL}>
                    <Input
                      maxLength={MAX_LENGTH_255}
                      size="large"
                      placeholder={inputPlaceholder}
                      onBlur={(event) => {
                        state.formModal.setFieldValue(
                          FORM_NAME.EMAIL_MODAL,
                          event.target.value.trim()
                        );
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item {...FIELDS_CONFIG.MOBILE_PHONE_MODAL}>
                    <Input
                      maxLength={MAX_LENGTH_11}
                      size="large"
                      placeholder={inputPlaceholder}
                      onPaste={(e) => e.preventDefault()}
                      onKeyDown={(event: any) => {
                        if (
                          /^\d*$/.test(event.key) ||
                          LIST_KEYS_ALLOW_PHONE.includes(event.code)
                        ) {
                          return;
                        }

                        event.preventDefault();
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </ModalWrapper>

          {/* MODAL DELETE */}
          <ModalDeleteWrapper
            centered
            closeIcon={false}
            open={state.modalDelete}
            title={t("COMMON.DELETE")}
            confirmLoading={state.isLoading}
            onOk={handler.handleOkModalDelete}
            onCancel={handler.handleCloseModalDelete}
            maskClosable={false}
            cancelText={cancelText}
            okText={t("COMMON.DELETE")}
            width={416}
          >
            <img src={images.commonDelete} alt="modal_delete" />
            <div className="store-page_modal-delete">
              <p>
                {state.store?.storeCode}_{state.store?.storeName}
              </p>
              <p>{t("STORE_PAGE.DELETE_CONFIRM")}</p>
            </div>
          </ModalDeleteWrapper>

          {/* MODAL REGIS/UPDATE CONFIRM FINAL */}
          <ModalDeleteWrapper
            centered
            closeIcon={false}
            open={state.modalConfirmFinal}
            title={state.renderTextModalConfirm.title}
            onOk={handler.handleOkModalConfirmFinal}
            onCancel={handler.handleCloseModalConfirmFinal}
            maskClosable={false}
            okText={state.renderTextModalConfirm.okText}
            cancelText={cancelText}
            width={412}
            zIndex={9999}
            confirmLoading={state.isLoading}
          >
            <img src={images.popUpConfirmFinal} alt="store_modal" />
            <div className="store-page_modal-confirm">
              <p>{state.renderTextModalConfirm.message}</p>
            </div>
          </ModalDeleteWrapper>

          {/* MODAL REGIS/UPDATE/DELETE SUCCESS */}
          <ModalDeleteWrapper
            centered
            closeIcon={false}
            open={state.modalSuccess}
            title={state.renderTextModal.title}
            onOk={handler.handleCloseModalSuccessFail}
            maskClosable={false}
            okText={state.renderTextModal.okText}
            width={412}
            okButtonProps={{ style: { width: "100%", marginInlineStart: 0 } }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <img src={images.confirmApproveTemperature} alt="store_modal" />
            <div className="store-page_modal-regist-success">
              <p>{state.renderTextModal.message}</p>
            </div>
          </ModalDeleteWrapper>

          {/* MODAL REGIS/UPDATE/DELETE FAIL */}
          <ModalDeleteWrapper
            centered
            closeIcon={false}
            open={state.modalFail}
            title={state.renderTextModal.title}
            onOk={handler.handleCloseModalSuccessFail}
            maskClosable={false}
            okText={state.renderTextModal.okText}
            width={412}
            okButtonProps={{ style: { width: "100%", marginInlineStart: 0 } }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <img src={images.importDataFail} alt="store_modal" />
            <div className="store-page_modal-regist-success">
              <p>{state.renderTextModal.message}</p>
            </div>
          </ModalDeleteWrapper>
        </LoadingCommon>
      )}
    </>
  );
}

export { StorePage };
